var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeedback(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "FeedbackICON",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      #FeedbackICON .cls-1 {\n        fill: var(--bg-color, #c5d75d);\n      }\n\n      #FeedbackICON .cls-2 {\n        fill: var(--color, #3e4346);\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16.0636-0H16.0295A16.0465 16.0465 90 1016.0636-0Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M22.7794 11.6777 22.1596 13.5733 20.1658 13.5773 21.7768 14.7525 21.1644 16.65 22.7801 15.4814 24.3958 16.65 23.7833 14.7525 25.3943 13.5773 23.4005 13.5733Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M16.9646 11.6777 16.3449 13.5733 14.3509 13.5773 15.9619 14.7525 15.3496 16.65 16.9652 15.4814 18.5809 16.65 17.9686 14.7525 19.5796 13.5773 17.5856 13.5733Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M11.1497 11.6777 10.53 13.5733 8.5361 13.5773 10.1471 14.7525 9.5347 16.65 11.1504 15.4814 12.7661 16.65 12.1537 14.7525 13.7647 13.5773 11.7709 13.5733Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M6.1976 24.703 8.0449 20.453A10.4063 10.4063 90 016.5255 15.0049 10.5409 10.5409 90 1111.9736 24.2478L6.7664 25.399A.5756.5756 90 016.6593 25.4058.4887.4887 90 016.2711 25.225.5094.5094 90 016.1976 24.703ZM10.789 23.4848 12.141 23.1837A8.7009 8.7009 90 0013.5799 23.8932 9.5536 9.5536 90 108.5468 19.295 8.6494 8.6494 90 008.9751 20.0648 2.8573 2.8573 90 009.1759 20.3593L8.7074 21.4368 7.5094 24.2077Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedback);
export default __webpack_public_path__ + "static/media/feedback.9716fd808c7fbf9e5a73d5824708c0eb.svg";
export { ForwardRef as ReactComponent };